<section role="region">
  <header role="banner" class="form-input__header" [class.form-input__header--isFlat]="isFlat">
    <p class="form-input__header__title" class="form-input__header__title" [innerHTML]="title"></p>
    <p *ngIf="question.subtitle" class="form-input__header__subtitle" [innerHTML]="subtitle"></p>
  </header>

  <div class="form-input__field form-input__field--yes-no" [class.form-input__field--yes-no--isFlat]="isFlat">
    <ng-container *ngFor="let option of options; trackBy: trackByOption">
      <label
        tabindex="0"
        [for]="elm_id + '-' + option.label"
        class="form-input__btn"
        [attr.selected]="option.value === value"
        (keydown.enter)="changeValue(option.value)"
        >{{ option.label | titlecase }}</label
      >

      <input
        type="checkbox"
        [id]="elm_id + '-' + option.label"
        [name]="option.label"
        class="form-input__hidden"
        (click)="changeValue(option.value)"
      />
    </ng-container>
  </div>
</section>
